<template>
  <div>
    <v-snackbar
      :color="snackbarColor"
      relative
      top
      :timeout="3000"
      v-model="snackbar"
      >{{ snackbarText }}</v-snackbar
    >

    <v-data-table
      :headers="headers"
      :items="errands"
      :items-per-page="10"
      :loading="loading"
      sort-by="name"
      class="mt-5"
      :sort-desc="true"
      :search="searchTerm"
      item-key=".key"
      :footer-props="{
        itemsPerPageOptions: [10, 50, 100],
      }"
    >
      <template v-slot:[`item.progressCurrentStatus`]="{ item }">
        <v-chip
          v-if="item.state == 'placed' && item.source == 'scheduled'"
          class="white--text font-weight-bold"
          color="#606060"
        >
          <span class="blink_me"></span>
          Programada
        </v-chip>

        <v-chip
          v-else
          class="white--text"
          :color="getColor(item.progressCurrentStatus)"
          >{{ item.progressCurrentStatus | statusFilter }}</v-chip
        >
      </template>

      <template v-slot:[`item.deliveryDistance`]="{ item }">
        {{
          item.distance ? item.distance : item.deliveryDistance.toFixed(2) || 0
        }}
        KM
      </template>

      <template v-slot:[`item.deliveryCost`]="{ item }">
        {{ item.deliveryCost.toFixed(2) | currency }}
      </template>

      <template v-slot:[`item.progressCreatedAt`]="{ item }">
        {{ item.progressCreatedAt | tsToDate }}
      </template>

      <template v-slot:[`item.options`]="{ item }">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              color="gray"
              :loading="loading"
              v-on="on"
              :disabled="
                item.progressCurrentStatus != 'delivered' &&
                item.progressCurrentStatus != 'completed'
              "
              :dark="$vuetify.theme.dark"
              x-small
              @click="downloadInvoice(item)"
              :elevation="0"
            >
              <v-icon color="primary" dark>fas fa-file-invoice</v-icon>
            </v-btn>
          </template>
          <span>Descargar comprobante</span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              color="gray"
              :loading="loading"
              v-on="on"
              :dark="$vuetify.theme.dark"
              x-small
              @click="showDetails(item)"
              :elevation="0"
            >
              <v-icon color="blue" dark>fas fa-info</v-icon>
            </v-btn>
          </template>
          <span>Ver detalles</span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              color="red"
              :loading="loading"
              v-on="on"
              :disabled="item.state != 'placed' || item.source != 'scheduled'"
              :dark="$vuetify.theme.dark"
              x-small
              @click="cancelErrand(item)"
              :elevation="0"
            >
              <v-icon color="white" dark>fas fa-ban</v-icon>
            </v-btn>
          </template>
          <span>Cancelar</span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              color="secondary"
              :loading="loading"
              v-on="on"
              :disabled="
                !['accepted', 'enRoute', 'onDelivery'].includes(
                  item.progressCurrentStatus
                )
              "
              @click="showTracking(item)"
              :dark="$vuetify.theme.dark"
              x-small
              :elevation="0"
            >
              <v-icon color="white" dark>fas fa-map-marked-alt</v-icon>
            </v-btn>
          </template>
          <span>Tracking</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.shortId`]="{ item }">
        <v-tooltip v-if="item.shortId" right>
          <template v-slot:activator="{ on }">
            <v-chip
              :color="
                $vuetify.theme.dark
                  ? 'rgba(0, 0, 0, 0.4)'
                  : 'rgba(0, 0, 0, 0.1)'
              "
              style="display: inline-block"
              v-on="on"
              dark
              :text-color="$vuetify.theme.dark ? 'white' : 'black'"
              @click="copyToClipboard(item.shortId)"
            >
              {{ item.shortId }}
            </v-chip>
          </template>
          <i class="far fa-copy mr-2"></i>
          <span>Click para copiar</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog
      v-model="detailsDialog"
      v-if="detailsDialog && selectedErrand"
      max-width="700"
      persistent
    >
      <order-details
        @cancel="detailsDialog = false"
        :order="selectedErrand"
      ></order-details>
    </v-dialog>

    <v-dialog
      v-model="cancelDialog"
      v-if="cancelDialog && selectedErrand"
      max-width="500"
      persistent
    >
      <cancel-errand
        @cancel="cancelDialog = false"
        @confirm="cancelConfirmed"
        :order="selectedErrand"
      ></cancel-errand>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");
import orderDetails from "@/components/order-details";
import cancelErrand from "@/components/cancel-errand";
import { db } from "@/firebase";

import { mapState } from "vuex";

export default {
  name: "tracking_orders",
  props: ["errands"],
  components: {
    orderDetails,
    cancelErrand,
  },
  data() {
    return {
      detailsDialog: false,
      selectedErrand: null,
      loading: false,
      snackbarText: "",
      snackbar: false,
      snackbarColor: "red darken-2",
      cancelDialog: false,
      headers: [
        { text: "Estado", value: "progressCurrentStatus" },
        { text: "ID", value: "shortId" },
        { text: "Costo de Envío", value: "deliveryCost" },
        { text: "Distancia", value: "deliveryDistance" },
        {
          text: "Fecha Creación",
          value: "progressCreatedAt",
        },
        {
          text: "",
          value: "options",
          align: "end",
        },
      ],
    };
  },
  computed: {
    ...mapState(["searchTerm", "user"]),
  },
  filters: {
    currency: function (amount) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HNL",
        minimumFractionDigits: 2,
      });
      return formatter.format(amount);
    },
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      var splitStr = value.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return " " + splitStr.join(" ");
    },

    date(data) {
      return data ? moment.utc(data).format("DD/MM/YYYY") : "";
    },

    tsToDate: function (timestamp) {
      if (!timestamp) return "n/a";
      return moment(timestamp.toDate())
        .tz("America/Tegucigalpa")
        .format("DD/MM/YYYY, hh:mm A");
    },
    tsToRelative: function (timestamp) {
      if (!timestamp) return "n/a";
      return moment(timestamp.toDate()).tz("America/Tegucigalpa").fromNow();
    },

    statusFilter: function (status) {
      switch (status) {
        case "scheduled":
          return "Programada";
          break;

        case "placed":
          return "Colocada";
          break;

        case "accepted":
          return "Aceptada";
          break;

        case "assigned":
          return "Asignada";
          break;

        case "enRoute":
          return "En Camino";
          break;

        case "delivered":
          return "Entregada";
          break;

        case "completed":
          return "Completada";
          break;

        case "canceled":
          return "Cancelada";
          break;

        case "rejected":
          return "Rechazada";
          break;

        case "undeliverable":
          return "No Entregada";
          break;

        default:
          return status;
          break;
      }
    },
  },

  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(
        () => {
          this.snackbar = true;
          this.snackbarText = "Copiado al portapapeles";
        },
        (err) => {
          console.error("Async: Could not copy text: ", err);
        }
      );
    },

    showTracking(item) {
      console.log(item.shortId);

      window.open(`${process.env.VUE_APP_TRACKING_LINK}/${item.shortId}`);
    },

    cancelErrand(errand) {
      this.selectedErrand = errand;
      this.cancelDialog = true;
    },
    cancelConfirmed() {
      this.cancelDialog = false;
      this.loading = true;

      db.collection("scheduledOrders")
        .doc(this.selectedErrand[".key"])
        .update({
          state: "canceled",
          canceledAt: new Date(),
          canceledBy: this.user[".key"],
        })
        .then(() => {
          this.snackbarText = "Mandado cancelado exitosamente.";
          this.snackbar = true;
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
          this.loading = false;
        });
    },
    getColor(status) {
      switch (status) {
        case "placed":
          return "#c0ca33";
          break;

        case "accepted":
          return "#4caf50";
          break;

        case "enRoute":
          return "#FFBF00";
          break;

        case "delivered":
          return "#00bcd4";
          break;

        case "completed":
          return "#2196f3";
          break;

        case "canceled":
          return "grey";
          break;

        case "rejected":
          return "red";
          break;

        default:
          return "gray";
          break;
      }
    },
    showDetails(errand) {
      this.selectedErrand = errand;
      this.detailsDialog = true;
    },

    downloadInvoice(item) {
      if (
        item.progressCurrentStatus == "completed" ||
        item.progressCurrentStatus == "delivered"
      ) {
        this.loading = true;

        fetch(
          `${process.env.VUE_APP_FUNCTIONS_URL}/httpInvoicingGenerate?orderId=${item.shortId}&type=errandProof`,
          { responseType: "blob" }
        )
          .then((response) => {
            if (response.ok) {
              return response.blob();
            } else {
              throw new Error("Something went wrong");
            }
          })
          .then((blob) => URL.createObjectURL(blob))
          .then((uril) => {
            var link = document.createElement("a");
            link.href = uril;
            link.download = `${item.shortId}_comprobante.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.loading = false;
          })
          .catch(() => {
            this.snackbarText =
              "Ocurrió un error inesperado al generar el comprobante, inténtelo nuevamente.";
            this.snackbar = true;
            this.snackbarColor = "red darken-2";
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.titleContainer {
  h1 {
    font-size: 28px;
    line-height: 28px;
    span {
      font-size: 16px;
      line-height: 16px;
      display: block;
      color: #666;
    }
  }

  .actions {
    display: flex;
    justify-content: space-between;
  }
}
.trackingContainer {
  text-align: left;
  &.navBarActive {
    padding-left: 130px;
  }

  .errandsHeader {
    margin-left: 10px;
    margin-right: 30px;
    margin-top: 10px;
    line-height: 16px;
    border-radius: 18px;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    filter: drop-shadow(0px 0px 3px rgba(#000000, 0.4));
    padding: 10px 10px 10px 0;
    position: relative;

    span {
      font-weight: bold;
      color: #111;
      border-right: 1px solid #eee;
      width: 100%;
      text-align: left;
      padding: 10px;

      &.date {
        min-width: 175px;
      }

      &:last-of-type {
        border-right: none;
      }
    }
  }
}

.number {
  background-color: #FF1744;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  color: white;
  padding: 3px;
  margin-right: 10px;
}

.point {
  padding: 15px;
}

.point-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  max-width: 100%;
  overflow: hidden;
}

.detail {
  text-align: left;
  padding: 5px;
  margin-left: 10px;
  font-size: 16px;

  max-width: 100%;
  overflow: hidden;
}

.view {
  font-size: 13px;
  text-align: start;
  margin-left: 15px;
  margin-top: 10px;
}

.view a {
  cursor: pointer;
  color: #002679;
}

.cost {
  background-color: #ffceb57a;
  height: 100%;
}

.close {
  width: 20px;
}

.status {
  border-radius: 40px;
  color: white;
  padding: 10px;
  width: 90%;
  max-width: 90%;
  text-align: center;
}

.option {
  padding: 10px;
}

.no-result {
  text-align: center;
  margin-top: 7%;
  color: gray;
  font-size: 25px;
}

.disabled {
  background-color: rgb(196, 196, 196);
  cursor: default;
}

.blink_me {
  // font-weight: bold;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background-color: rgb(255, 1, 1);
  border-radius: 50%;
  animation: blinker 1.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 50%;
  }
}
</style>